export function getVersionFromSubdomain() {
  let version = 'zerokey';
  // Get the subdomain from the URL
  const hostname = window.location.hostname;

  // Check if we have a subdomain
  if (hostname.includes('.')) {
    const parts = hostname.split('.');

    // If we have more than 2 parts (like 'app.zerokey.com'), the first part is the subdomain
    if (parts.length > 2) {
      const baseVersions = ['zerokey', 'app', 'api', 'alpha'];
      if (!baseVersions.includes(parts[0])) {
        version = parts[0];
      }
    }
  }

  return version;
}

export function getAppNameFromSubdomain() {
  const version = getVersionFromSubdomain();
  return version === 'intelliflo' ? 'intelliflo zerokey' : 'ZeroKey';
}
